/* Nextmac keuzemenu (Swappie-stijl)
   - Direct bijwerken van prijsverschillen, uitleg, samenvatting en balk bij een keuze
     (uit window.nmProductCache, gevuld door product-variant-picker.liquid).
     Daarna vervangt Dawn de hele <variant-selects> met de server-versie (~1 s).
   - Vaste balk bovenin die verschijnt zodra de producttitel uit beeld is. */
(function () {
  if (window.nmKeuzemenu) return;
  window.nmKeuzemenu = true;

  /* ---------- Geld ---------- */
  function geld(cents, format) {
    format = format || '€{{amount_with_comma_separator}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var soort = m ? m[1] : 'amount';
    function num(n, dec, duizend, komma) {
      var s = (Math.abs(n) / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return s[1] ? s[0] + komma + s[1] : s[0];
    }
    var uit;
    switch (soort) {
      case 'amount_no_decimals': uit = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': uit = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': uit = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': uit = num(cents, 2, "'", '.'); break;
      default: uit = num(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, uit);
  }
  function geldKort(cents, format) {
    // zelfde als Liquid money_without_trailing_zeros
    return geld(cents, format).replace(/[.,]00(?!\d)/, '');
  }
  // Prijsverschil in een rij: "+ €50" (meerprijs) of "- €50" (minbedrag, zelfde stijl; span .nm-km__min als haakje)
  function zetVerschil(meta, voor, d, fmt) {
    meta.textContent = voor;
    if (!d) return;
    if (voor) meta.appendChild(document.createTextNode(' · '));
    if (d > 0) { meta.appendChild(document.createTextNode('+ ' + geldKort(d, fmt))); return; }
    var s = document.createElement('span');
    s.className = 'nm-km__min';
    s.textContent = '- ' + geldKort(-d, fmt);
    meta.appendChild(s);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function zet(root, sel, tekst) {
    if (!root) return;
    var el = root.querySelector(sel);
    if (el) el.textContent = tekst;
  }

  /* ---------- Direct bijwerken bij keuze ---------- */
  function productVoor(vs) {
    var pi = vs.closest('product-info');
    var cache = window.nmProductCache;
    var p = pi && cache && cache[pi.dataset.url];
    return p && p.variants ? p : null;
  }

  function vindVariant(p, keuze) {
    for (var i = 0; i < p.variants.length; i++) {
      var o = p.variants[i].options, ok = true;
      for (var j = 0; j < o.length; j++) if (o[j] !== keuze[j]) { ok = false; break; }
      if (ok) return p.variants[i];
    }
    return null;
  }

  // Gewicht per optie: wat het minst mag veranderen. Particulier/Zakelijk > RAM/opslag (Configuratie) > Kleur > Conditie.
  // Zelfde gewichten als nm-keuzemenu.liquid.
  function optieGewicht(naam) {
    naam = String(naam || '').toLowerCase();
    if (naam.indexOf('particulier') > -1 || naam.indexOf('zakelijk') > -1) return 16;
    if (naam === 'configuratie' || naam.indexOf('opslag') > -1 || naam === 'ram' || naam.indexOf('geheugen') > -1) return 8;
    if (naam === 'kleur') return 4;
    if (naam.indexOf('conditie') > -1) return 2;
    return 1;
  }
  // Dichtstbijzijnde leverbare variant(en) met waarde 'w' op plek i: zo weinig mogelijk andere keuzes aanpassen
  // (gewichten hierboven). Alle varianten met die beste score zijn kandidaten; gekozen wordt de goedkoopste.
  // Zelfde regel als nm-keuzemenu.liquid en de klik-handler hieronder.
  function besteAlternatieven(p, keuze, i, w) {
    var max = -1, lijst = [];
    var gew = (p.options || []).map(function (o) { return optieGewicht(typeof o === 'string' ? o : o.name); });
    p.variants.forEach(function (x) {
      if (!x.available || x.options[i] !== w) return;
      var n = 0;
      x.options.forEach(function (o, j) { if (j !== i && o === keuze[j]) n += gew[j] || 1; });
      if (n > max) { max = n; lijst = [x]; } else if (n === max) lijst.push(x);
    });
    if (!lijst.length) return null;
    var beste = lijst[0];
    lijst.forEach(function (x) { if (x.price < beste.price) beste = x; });
    return { beste: beste, kandidaten: lijst };
  }
  function besteAlternatief(p, keuze, i, w) { var r = besteAlternatieven(p, keuze, i, w); return r ? r.beste : null; }

  // Hint bij een keuze die in deze combinatie niet leverbaar is: alleen wat er verandert, kort.
  // Met "alleen" ervoor. Eén waarde ("alleen met Premium", "alleen met 8 GB / 512 GB"); bij Kleur alle kleuren met verder dezelfde keuzes ("in Spacegrijs en Goud").
  function altHint(p, keuze, i, r, ri) {
    var namen = (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name || '').toLowerCase(); });
    var b = r.beste, delen = [];
    keuze.forEach(function (k, j) {
      if (j === i || b.options[j] === k) return;
      if (namen[j] !== 'kleur') { delen.push('met ' + b.options[j] + (j === ri ? ' RAM' : '')); return; }
      var vals = [];
      p.variants.forEach(function (x) {
        if (!x.available || x.options[i] !== b.options[i]) return;
        for (var m = 0; m < x.options.length; m++) if (m !== i && m !== j && x.options[m] !== b.options[m]) return;
        if (vals.indexOf(x.options[j]) === -1) vals.push(x.options[j]);
      });
      var volg = (p.options[j] && p.options[j].values) || [];
      vals.sort(function (x, y) { return volg.indexOf(x) - volg.indexOf(y); });
      delen.push('in ' + (vals.length > 1 ? vals.slice(0, -1).join(', ') + ' en ' + vals[vals.length - 1] : vals[0]));
    });
    return delen.length ? 'alleen ' + delen.join(', ') : '';
  }

  function snelBijwerken(vs) {
    var groepen = [].slice.call(vs.querySelectorAll('fieldset'));
    var keuze = groepen.map(function (g) {
      var k = g.querySelector('input[type=radio]:checked');
      return k ? k.value : null;
    });

    // Uitleg kan altijd (staat in data-uitleg)
    groepen.forEach(function (g) {
      var k = g.querySelector('input[type=radio]:checked');
      var vak = g.querySelector('[data-nm-km-uitleg]');
      if (!k || !vak) return;
      var t = k.dataset.uitleg || '';
      vak.classList.toggle('is-leeg', !t);
      vak.innerHTML = t ? '<strong>' + escapeHtml(k.value) + ':</strong> ' + escapeHtml(t).replace(/\n/g, '<br>') : '';
    });

    var p = productVoor(vs);
    if (!p) return;
    var huidig = vindVariant(p, keuze);
    if (!huidig) return;
    var fmt = vs.dataset.moneyFormat;

    // Prijsverschillen per rij
    groepen.forEach(function (g, i) {
      [].forEach.call(g.querySelectorAll('input[type=radio]'), function (r) {
        var label = r.nextElementSibling;
        if (!label) return;
        // 06-10 (Sem): conditie-rij toont het verschil met de uitvoering waar de klik echt naartoe springt (goedkoopste leverbare in die conditie, Particulier/Zakelijk blijft staan)
        var optNm = String(typeof p.options[i] === 'string' ? p.options[i] : (p.options[i] && p.options[i].name) || '').toLowerCase();
        if (optNm.indexOf('conditie') > -1) {
          var meta0 = label.querySelector('.nm-km__meta');
          var vast0 = (p.options || []).map(function (o) { return optieGewicht(typeof o === 'string' ? o : o.name) >= 16; });
          var gk = null;
          p.variants.forEach(function (x) { if (!x.available || x.options[i] !== r.value) return; for (var j = 0; j < x.options.length; j++) if (j !== i && vast0[j] && x.options[j] !== keuze[j]) return; if (!gk || x.price < gk.price) gk = x; });
          label.classList.toggle('nm-km__rij--uit', !gk && !r.checked);
          r.disabled = !gk && !r.checked;
          if (!meta0) return;
          meta0.classList.remove('nm-km__meta--via');
          if (r.checked) meta0.textContent = '';
          else if (gk) zetVerschil(meta0, '', gk.price - huidig.price, fmt);
          else meta0.textContent = 'Niet op voorraad';
          return;
        }
        var meta = label.querySelector('.nm-km__meta');
        var poging = keuze.slice();
        poging[i] = r.value;
        var v = vindVariant(p, poging);
        var leverbaar = !!(v && v.available);
        var altR = (!leverbaar && !r.checked) ? besteAlternatieven(p, keuze, i, r.value) : null;
        var alt = altR ? altR.beste : null;
        label.classList.toggle('nm-km__rij--uit', !leverbaar && !alt && !r.checked);
        r.disabled = !leverbaar && !alt && !r.checked;
        if (!meta) return;
        meta.classList.toggle('nm-km__meta--via', !!alt);
        if (r.checked) meta.textContent = '';
        else if (leverbaar) {
          var d = v.price - huidig.price;
          zetVerschil(meta, '', d, fmt);
        } else if (alt) {
          var ri = parseInt(vs.dataset.ramIndex, 10);
          var da = alt.price - huidig.price;
          zetVerschil(meta, altHint(p, keuze, i, altR, ri), da, fmt);
        } else meta.textContent = 'Niet op voorraad';
      });
    });

    var cfg = volledigeConfig(vs, huidig.options);
    var prijs = geld(huidig.price, fmt);
    zet(vs, '.nm-km__config', cfg);
    zet(vs, '.nm-km__prijs', prijs);
    zet(balk, '.nm-km-balk__config', cfg);
    zet(balk, '.nm-km-balk__prijs', prijs);
    lanceringsprijsBijwerken(huidig.price, huidig.id);
  }

  // Zelfde opbouw als in nm-keuzemenu.liquid: Conditie | Chip | 8 GB RAM | 256 GB | Kleur | Toetsenbord

  // 06-10 (Sem): de server tekent de prijsverschillen opnieuw na elke keuze (en bij het laden) met de oude 'zelfde configuratie'-regel.
  // Daarom na het laden en na elke nieuwe versie van het keuzemenu de verschillen opnieuw berekenen met de echte sprong-logica.
  function nmVerschillenOpnieuw() { [].forEach.call(document.querySelectorAll('variant-selects.nm-km'), function (vs) { try { snelBijwerken(vs); } catch (e) {} }); }
  if (document.readyState !== 'loading') setTimeout(nmVerschillenOpnieuw, 0); else document.addEventListener('DOMContentLoaded', nmVerschillenOpnieuw);
  window.addEventListener('load', nmVerschillenOpnieuw);
  new MutationObserver(function (lijst) {
    var nieuw = lijst.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && ((n.matches && n.matches('variant-selects.nm-km, .nm-km')) || (n.querySelector && n.querySelector('variant-selects.nm-km'))); }); });
    if (nieuw) setTimeout(nmVerschillenOpnieuw, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function volledigeConfig(vs, opties) {
    var d = vs.dataset, ramIndex = parseInt(d.ramIndex, 10), delen = [];
    opties.forEach(function (o, i) {
      delen.push(i === ramIndex ? o + ' RAM' : o);
      if (i === 0 && d.chip) delen.push(d.chip);
    });
    if (d.kleur) delen.push(d.kleur);
    if (d.toetsenbord) delen.push(d.toetsenbord);
    return delen.join(' | ');
  }

  /* ---------- Apple lanceringsprijs + i-tooltip ---------- */
  // Prijs per configuratie: data-lp-map = {variant-id: prijs in euro} (snippets/nm-lanceringsprijs.liquid).
  // Onbekende configuratie: blok en balkregel verborgen, liever niets dan een verkeerde prijs.
  function lanceringsprijsBijwerken(prijsCenten, variantId) {
    if (typeof prijsCenten !== 'number') return;
    var np = null;
    [].forEach.call(document.querySelectorAll('[data-nm-lp]'), function (el) {
      var map = null;
      try { map = el.dataset.lpMap ? JSON.parse(el.dataset.lpMap) : null; } catch (e) { map = null; }
      var w = map && variantId != null ? parseFloat(map[String(variantId)]) : parseFloat(el.dataset.nieuwprijs);
      if (!(w > 0)) { el.hidden = true; sluitTooltips(); return; }
      np = w;
      el.hidden = false;
      el.dataset.nieuwprijs = w;
      var fmt = el.dataset.moneyFormat;
      var bedrag = el.querySelector('[data-nm-lp-bedrag]');
      if (bedrag && fmt) bedrag.textContent = geldKort(Math.round(w * 100), fmt);
      var pct = el.querySelector('[data-nm-lp-pct]');
      if (pct) pct.textContent = Math.round(prijsCenten / w);
    });
    if (!document.querySelector('[data-nm-lp]')) return;
    [].forEach.call(document.querySelectorAll('[data-nm-lp-balk]'), function (el) {
      var fmt = (document.querySelector('[data-nm-lp]') || {}).dataset.moneyFormat;
      el.hidden = !(np > 0);
      var bedrag = el.querySelector('[data-nm-lp-bedrag]');
      if (np > 0 && bedrag && fmt) bedrag.textContent = geldKort(Math.round(np * 100), fmt);
    });
  }
  function geselecteerdeVariant() {
    var vs = hoofd();
    var s = vs && vs.querySelector('[data-selected-variant]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function sluitTooltips(behalve) {
    [].forEach.call(document.querySelectorAll('[data-nm-lp]'), function (el) {
      if (el === behalve) return;
      var pop = el.querySelector('.nm-lp__pop'), knop = el.querySelector('.nm-lp__i');
      if (pop) pop.hidden = true;
      if (knop) knop.setAttribute('aria-expanded', 'false');
    });
  }
  function openTooltip(el) {
    var pop = el.querySelector('.nm-lp__pop'), knop = el.querySelector('.nm-lp__i');
    if (!pop || !knop) return;
    sluitTooltips(el);
    pop.hidden = false;
    knop.setAttribute('aria-expanded', 'true');
    // pijltje onder het i-icoon
    var pijl = knop.getBoundingClientRect().left - pop.getBoundingClientRect().left + knop.offsetWidth / 2 - 8;
    pop.style.setProperty('--nm-lp-pijl', Math.max(12, pijl) + 'px');
  }
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.nm-lp__i');
    if (knop) {
      e.preventDefault();
      var el = knop.closest('[data-nm-lp]');
      var pop = el && el.querySelector('.nm-lp__pop');
      if (pop && (pop.hidden || window.matchMedia('(hover: hover)').matches)) openTooltip(el); else sluitTooltips();
      return;
    }
    if (!(e.target.closest && e.target.closest('.nm-lp__pop'))) sluitTooltips();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sluitTooltips(); sluitBalkPop(); } });
  // ⓘ in de vaste balk: zelfde uitleg als bij de prijs op de pagina, onder de balk
  function sluitBalkPop() {
    var pop = balk && balk.querySelector('.nm-km-balk__pop');
    if (pop) pop.hidden = true;
    var k = balk && balk.querySelector('.nm-km-balk__i');
    if (k) k.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('.nm-km-balk__i');
    if (!k) {
      if (!(e.target.closest && e.target.closest('.nm-km-balk__pop'))) sluitBalkPop();
      return;
    }
    e.preventDefault();
    var pop = balk.querySelector('.nm-km-balk__pop');
    if (!pop) {
      pop = document.createElement('div');
      pop.className = 'nm-km-balk__pop';
      pop.hidden = true;
      balk.appendChild(pop);
    }
    if (!pop.hidden) { sluitBalkPop(); return; }
    var bron = document.querySelector('[data-nm-lp] .nm-lp__pop');
    if (!bron) return;
    pop.innerHTML = bron.innerHTML;
    pop.hidden = false;
    k.setAttribute('aria-expanded', 'true');
  });
  window.addEventListener('scroll', function () { if (balk && !balk.classList.contains('is-zichtbaar')) sluitBalkPop(); }, { passive: true });
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var el = e.target.closest && e.target.closest('[data-nm-lp]');
      if (el && e.target.closest('.nm-lp__i')) openTooltip(el);
    });
    document.addEventListener('mouseout', function (e) {
      var el = e.target.closest && e.target.closest('[data-nm-lp]');
      if (el && !el.contains(e.relatedTarget)) sluitTooltips();
    });
  }

  /* ---------- "Lees meer": open op het tabblad van de huidige keuze ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('variant-selects.nm-km [data-nm-open-modal]');
    if (!link) return;
    var groep = link.closest('fieldset');
    var gekozen = groep && groep.querySelector('input[type=radio]:checked');
    if (!gekozen) return;
    var waarde = gekozen.value.toLowerCase().replace(/\s+/g, '');
    setTimeout(function () {
      var modal = document.querySelector('.nm-info-modal[data-nm-modal="' + link.dataset.nmOpenModal + '"]');
      if (!modal) return;
      var tabs = [].slice.call(modal.querySelectorAll('.nm-info-modal__tab'));
      var doel = tabs.filter(function (t) {
        var a = (t.dataset.nmTab || '').toLowerCase().replace(/\s+/g, '');
        var b = t.textContent.toLowerCase().replace(/\s+/g, '');
        return a === waarde || b === waarde;
      })[0] || tabs.filter(function (t) {
        return waarde.indexOf(t.textContent.toLowerCase().replace(/\s+|\+/g, '')) === 0;
      })[0];
      if (doel && !doel.classList.contains('nm-info-modal__tab--active')) doel.click();
    }, 0);
  });

  /* ---------- Keuze die in deze combinatie niet leverbaar is ----------
     Alle andere keuzes blijven staan als de combinatie leverbaar is (dus geen sprong naar een andere kleur of
     configuratie). Is ze niet leverbaar, dan zo weinig mogelijk aanpassen (Particulier/Zakelijk > Configuratie > Kleur > Conditie) en
     bij gelijke keus de goedkoopste. Capture-fase op window: loopt vóór het automatisch-bijsturen-script
     (nm-variant-picker-origineel) en vóór Dawn de gekozen opties uitleest. */
  window.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var vs = t.closest && t.closest('variant-selects.nm-km');
    if (!vs) return;
    var groepen = [].slice.call(vs.querySelectorAll('fieldset'));
    var i = groepen.indexOf(t.closest('fieldset'));
    if (i < 0) return;
    var p = productVoor(vs);
    if (!p || p.options.length !== groepen.length) return;
    var keuze = groepen.map(function (g) {
      var k = g.querySelector('input[type=radio]:checked');
      return k ? k.value : null;
    });
    // 03-10 (Sem): andere CONDITIE gekozen -> direct naar de goedkoopste leverbare uitvoering in die conditie
    // (configuratie en kleur mogen veranderen; Particulier/Zakelijk blijft staan), zodat de klant altijd eerst de laagste prijs ziet.
    var optNaam = String(typeof p.options[i] === 'string' ? p.options[i] : (p.options[i] && p.options[i].name) || '').toLowerCase();
    if (optNaam.indexOf('conditie') > -1) {
      var vast = (p.options || []).map(function (o) { return optieGewicht(typeof o === 'string' ? o : o.name) >= 16; });
      var goedkoopst = null;
      p.variants.forEach(function (x) {
        if (!x.available || x.options[i] !== t.value) return;
        for (var j = 0; j < x.options.length; j++) if (j !== i && vast[j] && x.options[j] !== keuze[j]) return;
        if (!goedkoopst || x.price < goedkoopst.price) goedkoopst = x;
      });
      if (goedkoopst) {
        groepen.forEach(function (g, j) {
          if (j === i) return;
          [].forEach.call(g.querySelectorAll('input[type=radio]'), function (r) { r.checked = r.value === goedkoopst.options[j]; });
        });
        return;
      }
    }
    var v = vindVariant(p, keuze);
    if (v && v.available) return;
    var doel = besteAlternatief(p, keuze, i, t.value);
    if (!doel) return;
    groepen.forEach(function (g, j) {
      if (j === i) return;
      [].forEach.call(g.querySelectorAll('input[type=radio]'), function (r) {
        r.checked = r.value === doel.options[j];
      });
    });
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var vs = t.closest && t.closest('variant-selects.nm-km');
    if (!vs) return;
    laatsteKeuze = t.id || null;
    // na het automatisch-bijsturen-script van Nextmac (capture) uitvoeren
    setTimeout(function () { houdPlek(t, function () { snelBijwerken(vs); }); }, 0);
  });

  /* ---------- Niet verspringen bij een keuze (mobiel en desktop) ----------
     1. Dawn zet bij een variantwissel de nieuwe <variant-selects> boven de oude en verbergt de oude met
        style="display:none". Onze CSS gebruikt !important, dus beide stonden even (500 ms) zichtbaar onder elkaar:
        de pagina werd ~1200px langer en iPhones (geen scroll-anchoring) sprongen naar beneden.
        Hier: eerst de oude verbergen, dan de nieuwe plaatsen, en de aangeklikte keuze op dezelfde plek op het scherm houden.
     2. Dawn zet daarna de focus op de aangeklikte keuze; zonder preventScroll kan de browser daarvoor scrollen. */
  var laatsteKeuze = null;
  function houdPlek(el, fn) {
    var label = el && el.id ? document.querySelector('label[for="' + cssId(el.id) + '"]') : null;
    var voor = label ? label.getBoundingClientRect().top : null;
    fn();
    if (voor === null || !label.isConnected) return;
    var d = label.getBoundingClientRect().top - voor;
    if (Math.abs(d) > 1) window.scrollBy(0, d);
  }
  function cssId(id) { return window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/"/g, '\\"'); }
  function patchWissel() {
    if (typeof HTMLUpdateUtility === 'undefined' || HTMLUpdateUtility.nmPatch) return;
    HTMLUpdateUtility.nmPatch = true;
    HTMLUpdateUtility.viewTransition = function (oldNode, newContent, pre, post) {
      (pre || []).forEach(function (cb) { cb(newContent); });
      var wrap = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(wrap, newContent.outerHTML);
      var newNode = wrap.firstChild;

      // anker: de laatst aangeklikte keuze (of anders de bovenkant van het blok zelf)
      var id = laatsteKeuze, anker = null, voor = 0;
      if (id) {
        var l = oldNode.querySelector('label[for="' + cssId(id) + '"]');
        if (l && l.offsetParent !== null) anker = l;
      }
      if (!anker && oldNode.offsetParent !== null) anker = oldNode;
      if (anker) voor = anker.getBoundingClientRect().top;

      var uniek = Date.now();
      oldNode.querySelectorAll('[id], [form]').forEach(function (el) {
        if (el.id) el.id = el.id + '-' + uniek;
        if (el.form) el.setAttribute('form', el.form.getAttribute('id') + '-' + uniek);
      });
      oldNode.style.setProperty('display', 'none', 'important');
      oldNode.parentNode.insertBefore(newNode, oldNode);
      (post || []).forEach(function (cb) { cb(newNode); });

      if (anker) {
        var nieuw = anker === oldNode ? newNode : newNode.querySelector('label[for="' + cssId(id) + '"]');
        if (nieuw && nieuw.getBoundingClientRect) {
          var d = nieuw.getBoundingClientRect().top - voor;
          if (Math.abs(d) > 1) window.scrollBy(0, d);
        }
      }
      setTimeout(function () { oldNode.remove(); }, 500);
    };
  }
  patchWissel();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', patchWissel);
  window.addEventListener('load', patchWissel);
  var focusOrigineel = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (opties) {
    if (this.closest && this.closest('variant-selects, product-info')) {
      var o = {}; if (opties) for (var k in opties) o[k] = opties[k];
      o.preventScroll = true;
      return focusOrigineel.call(this, o);
    }
    return focusOrigineel.apply(this, arguments);
  };

  /* ---------- Vaste balk ---------- */
  var balk = null, onder = null;
  function hoofd() {
    return document.querySelector('variant-selects.nm-km[data-nm-km-main]');
  }
  function vulBalk() {
    var vs = hoofd();
    var t = vs && vs.querySelector('template[data-nm-km-balk]');
    if (!t) return;
    if (!balk) {
      balk = document.createElement('div');
      balk.className = 'nm-km-balk';
      balk.setAttribute('aria-hidden', 'true');
      document.body.appendChild(balk);
    }
    balk.innerHTML = t.innerHTML;
    // Kleur in de titel apart, zodat die op mobiel weg kan (staat al in de configuratieregel)
    var tt = balk.querySelector('.nm-km-balk__titel'), kl = vs.dataset.kleur;
    if (tt && kl && tt.textContent.slice(-kl.length - 1) === ' ' + kl) {
      tt.textContent = tt.textContent.slice(0, -kl.length - 1);
      var sp = document.createElement('span');
      sp.className = 'nm-km-balk__kleur';
      sp.textContent = ' ' + kl;
      tt.appendChild(sp);
    }
    if (!onder) {
      // Mobiel: winkelwagenknop onderin (Swappie-stijl); op desktop verborgen via CSS
      onder = document.createElement('div');
      onder.className = 'nm-km-onder';
      var tekstOnder = (window.variantStrings && window.variantStrings.addToCart) || 'Toevoegen aan winkelwagen';
      onder.innerHTML = '<button type="button" class="nm-km-onder__knop" data-nm-km-atc></button>';
      onder.firstChild.dataset.tekst = tekstOnder;
      onder.firstChild.textContent = tekstOnder;
      document.body.appendChild(onder);
      document.body.classList.add('nm-heeft-onderbalk');
    }
    knopBijwerken();
    var v = geselecteerdeVariant();
    if (v) lanceringsprijsBijwerken(v.price, v.id);
    positie();
  }
  function hoofdKnop() {
    var vs = hoofd();
    var pi = vs && vs.closest('product-info');
    return pi && pi.querySelector('product-form button[name=add], product-form [type=submit]');
  }
  function eigen(el) { return (balk && balk.contains(el)) || (onder && onder.contains(el)); }
  function knopBijwerken() {
    var h = hoofdKnop();
    if (!h) return;
    var uit = h.disabled || h.getAttribute('aria-disabled') === 'true';
    // Niet leverbaar: Dawn zet dan de tekst van de knop (bv. "Niet op voorraad"); tijdens laden is de knop alleen even disabled
    var vs = window.variantStrings || {};
    var hoofdTekst = ((h.querySelector('span') || h).textContent || '').trim();
    var weg = uit && hoofdTekst && hoofdTekst !== vs.addToCart &&
      (hoofdTekst === vs.soldOut || hoofdTekst === vs.unavailable || /uitverkocht|niet op voorraad|niet beschikbaar|sold out/i.test(hoofdTekst));
    var kleur = getComputedStyle(h).backgroundColor;
    [balk, onder].forEach(function (houder) {
      var k = houder && houder.querySelector('[data-nm-km-atc]');
      if (!k) return;
      if (k.disabled !== uit) k.disabled = uit;
      var tekst = weg ? hoofdTekst : (k.dataset.tekst || 'In winkelwagen');
      if (k.textContent !== tekst) k.textContent = tekst;
      if (kleur && kleur !== 'rgba(0, 0, 0, 0)') k.style.setProperty('background', kleur, 'important');
    });
  }
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-nm-km-atc]');
    if (!k || k.disabled) return;
    var h = hoofdKnop();
    if (h && !h.disabled) h.click();
  });
  // Knopstatus volgen (Dawn zet disabled tijdens laden / bij uitverkocht)
  new MutationObserver(function (lijst) {
    for (var i = 0; i < lijst.length; i++) {
      if (!eigen(lijst[i].target)) { knopBijwerken(); return; }
    }
  })
    .observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  /* Balk: header blijft op deze pagina's altijd staan (zie CSS), dus alle maten zijn vast.
     Geen werk per scroll-frame meer: een IntersectionObserver op de titel schakelt de balk. */
  var kopH = -1, waarnemer = null;
  function kopHoogte() {
    var kop = document.querySelector('.section-header');
    if (!kop) return 0;
    var pos = getComputedStyle(kop).position;
    return pos === 'sticky' || pos === 'fixed' ? kop.offsetHeight : 0;
  }
  function maten() {
    if (!balk) return;
    var h = kopHoogte();
    balk.style.top = h + 'px';
    document.documentElement.style.setProperty('--nm-km-media-top', (h + balk.offsetHeight + 16) + 'px');
    if (h !== kopH) { kopH = h; kijk(); }
  }
  function kijk() {
    var vs = hoofd();
    if (!vs || !balk || !('IntersectionObserver' in window)) return;
    var pi = vs.closest('product-info') || document;
    var titel = pi.querySelector('.product__title') || vs;
    if (waarnemer) waarnemer.disconnect();
    waarnemer = new IntersectionObserver(function (items) {
      var e = items[items.length - 1];
      var zicht = !e.isIntersecting && e.boundingClientRect.top < kopH;
      balk.classList.toggle('is-zichtbaar', zicht);
    }, { rootMargin: '-' + kopH + 'px 0px 0px 0px', threshold: 0 });
    waarnemer.observe(titel);
  }
  function positie() { maten(); onderMaat(); onderStand(); }

  /* ---------- Winkelwagenknop onderin (mobiel): naadloos overgaan in de echte knop ----------
     Zelfde vorm en plek als de echte knop (breedte, hoogte, hoeken, letters). Zodra de echte knop de plek
     van de knop onderin bereikt, verdwijnt de knop onderin, zodat het lijkt alsof hij "vastklikt" (zoals Swappie).
     Is de echte knop weer uit beeld (verder gescrold), dan komt de knop onderin terug. */
  var mobiel = window.matchMedia('(max-width: 749px)');
  function onderMaat() {
    var h = hoofdKnop(), k = onder && onder.firstChild;
    if (!h || !k || !mobiel.matches || h.offsetParent === null) return;
    var cs = getComputedStyle(h), r = h.getBoundingClientRect();
    ['border-radius', 'height', 'font-size', 'font-weight', 'letter-spacing', 'font-family', 'text-transform', 'line-height'].forEach(function (eig) {
      k.style.setProperty(eig, cs.getPropertyValue(eig), 'important');
    });
    k.style.setProperty('min-height', cs.getPropertyValue('height'), 'important');
    onder.style.setProperty('padding-left', Math.round(r.left) + 'px', 'important');
    onder.style.setProperty('padding-right', Math.round(document.documentElement.clientWidth - r.right) + 'px', 'important');
  }
  function onderStand() {
    if (!onder) return;
    var weg = false, h = hoofdKnop();
    if (mobiel.matches && h && h.offsetParent !== null) {
      var r = h.getBoundingClientRect(), k = onder.firstChild.getBoundingClientRect();
      var boven = balk && balk.classList.contains('is-zichtbaar') ? balk.getBoundingClientRect().bottom : Math.max(0, kopH);
      weg = r.top <= k.top + 1 && r.bottom > boven;
    }
    if (onder.classList.contains('is-weg') !== weg) onder.classList.toggle('is-weg', weg);
  }
  var onderWacht = false;
  function onderPerFrame() {
    if (onderWacht) return;
    onderWacht = true;
    requestAnimationFrame(function () { onderWacht = false; onderStand(); });
  }
  window.addEventListener('scroll', onderPerFrame, { passive: true });
  window.addEventListener('resize', function () { onderMaat(); onderPerFrame(); });
  window.addEventListener('load', function () { onderMaat(); onderStand(); });

  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(maten, 150);
  });

  /* ---------- Geen gedachtestreepjes in de productbeschrijving ----------
     De beschrijving komt uit de productdata; " x - y " wordt "x: y", overige streepjes een koppelteken.
     (Meta-omschrijving, JSON-LD en FAQ worden al op de server gefilterd: snippets/nm-zonder-streep.liquid.) */
  function streepjesWeg() {
    [].forEach.call(document.querySelectorAll('[id^="ProductDescriptionAccordion"], [id^="ProductAccordion-"]'), function (vak) {
      var tw = document.createTreeWalker(vak, NodeFilter.SHOW_TEXT), n, lijst = [];
      while ((n = tw.nextNode())) if (/[–—]/.test(n.nodeValue)) lijst.push(n);
      lijst.forEach(function (t) {
        t.nodeValue = t.nodeValue.replace(/[  ][–—][  ]/g, ': ').replace(/[–—]/g, '-');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', streepjesWeg);
  else streepjesWeg();

  /* ---------- Popups met tabbladen: bij een ander tabblad altijd bovenaan beginnen ----------
     iOS toonde na het wisselen naar een korter tabblad (bv. "Onze belofte") de inhoud half uit beeld,
     zonder te kunnen scrollen: de oude scrollpositie bleef hangen. */
  function popupNaarBoven(modal) {
    [].forEach.call(modal.querySelectorAll('.nm-info-modal__content, .nm-info-modal__body'), function (el) { el.scrollTop = 0; });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.nm-info-modal__tab');
    var modal = tab && tab.closest('.nm-info-modal');
    if (!modal) return;
    popupNaarBoven(modal);
    requestAnimationFrame(function () { popupNaarBoven(modal); });
  }, true);

  /* ---------- "Kopen bij Nextmac": duidelijk maken dat de tabbladen opzij scrollen (mobiel) ---------- */
  var PIJLTJE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function tabsHint() {
    [].forEach.call(document.querySelectorAll('.nm-tabs__nav'), function (nav) {
      if (nav.dataset.nmHint) return;
      nav.dataset.nmHint = '1';
      var wrap = document.createElement('div');
      wrap.className = 'nm-tabs__navwrap';
      nav.parentNode.insertBefore(wrap, nav);
      wrap.appendChild(nav);
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'nm-tabs__meer';
      knop.setAttribute('aria-label', 'Meer tabbladen');
      knop.innerHTML = PIJLTJE;
      wrap.appendChild(knop);
      function stand() {
        var meer = nav.scrollWidth - nav.clientWidth > 2;
        var eind = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
        wrap.classList.toggle('is-meer-rechts', meer && !eind);
        wrap.classList.toggle('is-meer-links', meer && nav.scrollLeft > 2);
      }
      knop.addEventListener('click', function () {
        nav.scrollBy({ left: nav.clientWidth * 0.7, behavior: 'smooth' });
      });
      // aangeklikt tabblad helemaal in beeld schuiven (alleen opzij, de pagina blijft staan)
      nav.addEventListener('click', function (e) {
        var t = e.target.closest('.nm-tabs__tab');
        if (!t) return;
        var r = t.getBoundingClientRect(), n = nav.getBoundingClientRect();
        var d = (r.left + r.width / 2) - (n.left + n.width / 2);
        if (Math.abs(d) > 2) nav.scrollBy({ left: d, behavior: 'smooth' });
      });
      nav.addEventListener('scroll', stand, { passive: true });
      window.addEventListener('resize', stand);
      stand();
      // eenmalig kort laten zien dat je opzij kunt schuiven zodra de tabbladen in beeld komen
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (items) {
          if (!items[0].isIntersecting) return;
          io.disconnect();
          if (nav.scrollWidth - nav.clientWidth <= 2 || nav.scrollLeft > 2) return;
          setTimeout(function () {
            nav.scrollTo({ left: Math.min(56, nav.scrollWidth - nav.clientWidth), behavior: 'smooth' });
            setTimeout(function () { nav.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
          }, 300);
        }, { threshold: 1 });
        io.observe(nav);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tabsHint);
  else tabsHint();

  /* ---------- Fotogalerij: puntjes + pijltjes (thumbnails verborgen via CSS) ---------- */
  var PIJL = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function galerij() {
    if (!hoofd()) return;
    var mg = document.querySelector('product-info media-gallery');
    if (!mg || mg.dataset.nmGal) return;
    var viewer = mg.querySelector('slider-component[id^="GalleryViewer"]');
    var ul = viewer && viewer.querySelector('ul');
    if (!ul) return;
    mg.dataset.nmGal = '1';
    viewer.classList.add('nm-gal');

    function knop(richting) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nm-gal__pijl nm-gal__pijl--' + richting;
      b.setAttribute('aria-label', richting === 'vorige' ? 'Vorige foto' : 'Volgende foto');
      b.innerHTML = PIJL;
      return b;
    }
    var vorige = knop('vorige'), volgende = knop('volgende');
    viewer.appendChild(vorige);
    viewer.appendChild(volgende);
    var dots = document.createElement('div');
    dots.className = 'nm-gal__dots';
    viewer.parentNode.insertBefore(dots, viewer.nextSibling);

    function slides() {
      return [].filter.call(ul.children, function (li) { return li.tagName === 'LI' && li.offsetParent !== null; });
    }
    function huidige() {
      var s = slides(), best = 0, min = Infinity;
      if (!s.length) return 0;
      var basis = s[0].offsetLeft;
      s.forEach(function (li, i) {
        var d = Math.abs(li.offsetLeft - basis - ul.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function ga(i) {
      var s = slides();
      if (!s.length) return;
      i = (i + s.length) % s.length;
      ul.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
    }
    function markeer() {
      var i = huidige();
      [].forEach.call(dots.children, function (d, j) {
        d.classList.toggle('is-actief', i === j);
        d.setAttribute('aria-current', i === j ? 'true' : 'false');
      });
    }
    function teken() {
      var n = slides().length;
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'nm-gal__dot';
        d.setAttribute('aria-label', 'Foto ' + (i + 1) + ' van ' + n);
        d.dataset.i = i;
        dots.appendChild(d);
      }
      var weinig = n < 2;
      dots.hidden = weinig;
      vorige.hidden = weinig;
      volgende.hidden = weinig;
      markeer();
    }
    vorige.addEventListener('click', function () { ga(huidige() - 1); });
    volgende.addEventListener('click', function () { ga(huidige() + 1); });
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.nm-gal__dot');
      if (d) ga(parseInt(d.dataset.i, 10));
    });
    var bezigMarkeren = false;
    ul.addEventListener('scroll', function () {
      if (bezigMarkeren) return;
      bezigMarkeren = true;
      requestAnimationFrame(function () { bezigMarkeren = false; markeer(); });
    }, { passive: true });
    new MutationObserver(teken).observe(ul, { childList: true });
    teken();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', galerij);
  else galerij();

  // Na elke server-render van <variant-selects> de balk opnieuw vullen
  var bezig = false;
  new MutationObserver(function (lijst) {
    if (bezig) return;
    for (var i = 0; i < lijst.length; i++) {
      var n = lijst[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType === 1 && (n[j].matches('variant-selects.nm-km') || n[j].querySelector('variant-selects.nm-km'))) {
          bezig = true;
          requestAnimationFrame(function () { bezig = false; vulBalk(); streepjesWeg(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Ook op pagina's zonder nieuw menu: percentage bijwerken na elke variantwissel (Dawn pub/sub)
  function abonneer() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (v) lanceringsprijsBijwerken(v.price, v.id);
        knopBijwerken();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abonneer);
  else abonneer();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vulBalk);
  else vulBalk();
})();